const CONSENT_PARAM = 'consent_analytics';
const SOURCE_PARAM = 'consent_source';
const BANNER_PARAM = 'cookiesAccepted';
const GRANTED = 'granted';
const DENIED = 'denied';
const CCM19_TAG_MANAGER = 'Google Tag Manager';
const CCM19_EVENTS = ['ccm19WidgetLoaded', 'ccm19WidgetClosed', 'ccm19EmbeddingAccepted'];

function readSession(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function writeSession(key, value) {
  try {
    window.sessionStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
}

function readQuery(name) {
  try {
    return new URLSearchParams(window.location.search).get(name);
  } catch (e) {
    return null;
  }
}

function normalize(value) {
  if (value === GRANTED) {
    return GRANTED;
  }
  if (value === DENIED) {
    return DENIED;
  }
  return null;
}

export function detectExternalConsent() {
  const fromQuery = normalize(readQuery(CONSENT_PARAM));
  if (fromQuery !== null) {
    writeSession(CONSENT_PARAM, fromQuery);
    const source = readQuery(SOURCE_PARAM);
    if (source) {
      writeSession(SOURCE_PARAM, source);
    }
    return fromQuery;
  }
  return normalize(readSession(CONSENT_PARAM));
}

export function externalConsentSource() {
  return readSession(SOURCE_PARAM);
}

export function hasExternalConsent() {
  return detectExternalConsent() !== null;
}

function isTruthyFlag(value) {
  return value === true || value === 'true';
}

export function ccm19Enabled() {
  return Boolean(import.meta.env.VITE_CCM19_SCRIPT);
}

export function ccm19Consent() {
  const ccm = window.CCM;
  if (!ccm || !ccm.consent) {
    return null;
  }
  return (ccm.acceptedEmbeddings || []).some((e) => e.name === CCM19_TAG_MANAGER);
}

export function onConsentChange(callback) {
  if (!ccm19Enabled()) {
    return () => {};
  }
  const handler = () => callback(analyticsAllowed());
  CCM19_EVENTS.forEach((name) => window.addEventListener(name, handler));
  return () => CCM19_EVENTS.forEach((name) => window.removeEventListener(name, handler));
}

export function cookieBannerEnabled() {
  if (ccm19Enabled()) {
    return false;
  }
  const fromConfig = window.vue?.$store?.state?.app?.showCookieDisclaimer;
  if (typeof fromConfig !== 'undefined') {
    return isTruthyFlag(fromConfig);
  }
  return isTruthyFlag(import.meta.env.VITE_COOKIE_DISCLAIMER);
}

export function bannerConsent() {
  const stored = readSession(BANNER_PARAM);
  if (stored === 'true') {
    return true;
  }
  if (stored === 'false') {
    return false;
  }
  return null;
}

export function analyticsAllowed() {
  if (ccm19Enabled()) {
    return ccm19Consent() === true;
  }
  const external = detectExternalConsent();
  if (external !== null) {
    return external === GRANTED;
  }
  if (!cookieBannerEnabled()) {
    return true;
  }
  return bannerConsent() === true;
}

export default {
  detectExternalConsent,
  externalConsentSource,
  hasExternalConsent,
  ccm19Enabled,
  ccm19Consent,
  onConsentChange,
  cookieBannerEnabled,
  bannerConsent,
  analyticsAllowed,
};
